import { render, staticRenderFns } from "./Conversion.vue?vue&type=template&id=10a80b7d"
import script from "./Conversion.vue?vue&type=script&lang=js"
export * from "./Conversion.vue?vue&type=script&lang=js"
import style0 from "./Conversion.vue?vue&type=style&index=0&id=10a80b7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports